<div class="my-4 bg-card">
    <div class="mb-4">
        <div class="text-xl font-bold text-gray-800">Bitácora</div>
        <div class="text-sm text-secondary">Historial de cambios realizados</div>
    </div>

    <ng-container *ngIf="bitacora?.length; else sinBitacora">
        <div class="overflow-y-auto">
            <table class="w-full">
                <thead class="bg-gray-50">
                    <tr>
                        <th class="px-3 py-3 text-left font-semibold text-gray-700">Descripción</th>
                        <th class="px-3 py-3 text-left font-semibold text-gray-700">Fecha</th>
                        <th class="px-3 py-3 text-left font-semibold text-gray-700">Modificado Por</th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-gray-100">
                    <tr *ngFor="let registro of bitacora" class="hover:bg-gray-50">
                        <td class="px-3 py-2 text-sm text-gray-800">{{ registro.descripcion }}</td>
                        <td class="px-3 py-2 text-sm text-secondary">
                            {{ registro.fechaModificacion | date:'medium' }}
                        </td>
                        <td class="px-3 py-2">
                            <div class="text-sm font-semibold text-gray-800">
                                {{ registro.creadoPor?.nombreCompleto }}
                            </div>
                            <div class="text-xs text-secondary">
                                {{ registro.creadoPor?.email }}
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </ng-container>

    <ng-template #sinBitacora>
        <div class="flex flex-col items-center justify-center gap-2 py-10 text-secondary">
            <div class="text-base font-semibold text-gray-700">No hay registros en la bitácora</div>
            <div class="text-sm text-secondary">Cuando existan registros, aparecerán listados aquí.</div>
        </div>
    </ng-template>
</div>
